const primary = (theme) => ({
    type: "primary",
    color: theme.colors.white,
    background: theme.colors.primaryLight,
    border: theme.colors.primaryLight,
    focus: {
        border: theme.colors.primaryDark,
    },
    hover: {
        background: theme.colors.primary,
        border: theme.colors.primary,
    },
    active: {
        background: theme.colors.primaryDark,
        border: theme.colors.primaryDark,
    },
    disabled: {
        color: `rgba(${theme.colors.transparentBlack},0.2)`,
        background: `rgba(${theme.colors.transparentBlack},0.08)`,
        border: `rgba(${theme.colors.transparentBlack},0)`,
    },
});
const primaryInvertedOnColor = (theme) => ({
    type: "primaryInvertedOnColor",
    color: theme.colors.primaryLight,
    border: theme.colors.white,
    background: theme.colors.white,
    focus: {
        border: theme.colors.primaryDark,
    },
    hover: {
        background: `rgba(${theme.colors.transparentWhite},0.7)`,
        border: `rgba(${theme.colors.transparentWhite},0)`,
    },
    active: {
        background: theme.colors.primaryDark,
        border: theme.colors.primaryDark,
        color: theme.colors.white,
    },
    disabled: {
        background: `rgba(${theme.colors.transparentWhite},0.12)`,
        border: `rgba(${theme.colors.transparentWhite},0)`,
        color: `rgba(${theme.colors.transparentWhite},0.4)`,
    },
});
const secondary = (theme) => ({
    type: "secondary",
    color: theme.colors.black,
    border: theme.colors.black,
    background: "transparent",
    focus: {
        border: theme.colors.primaryLight,
    },
    hover: {
        background: `rgba(${theme.colors.transparentBlack},0.08)`,
    },
    active: {
        background: theme.colors.grey15,
        border: `rgba(${theme.colors.transparentBlack},0)`,
        color: theme.colors.white,
    },
    disabled: {
        background: "transparent",
        border: `rgba(${theme.colors.transparentBlack},0.26)`,
        color: `rgba(${theme.colors.transparentBlack},0.26)`,
    },
});
const secondaryInverted = (theme) => ({
    type: "secondaryInverted",
    border: theme.colors.white,
    color: theme.colors.white,
    background: "transparent",
    focus: {
        color: theme.colors.white,
        border: theme.colors.primaryLight,
    },
    hover: {
        background: `rgba(${theme.colors.transparentWhite},0.7)`,
        border: `rgba(${theme.colors.transparentWhite},0)`,
        color: theme.colors.black,
    },
    active: {
        background: theme.colors.white,
        border: theme.colors.white,
        color: theme.colors.black,
    },
    disabled: {
        background: "transparent",
        border: `rgba(${theme.colors.transparentWhite},0.4)`,
        color: `rgba(${theme.colors.transparentWhite},0.4)`,
    },
});
const flat = (theme) => ({
    type: "flat",
    color: theme.colors.black,
    border: `rgba(${theme.colors.transparentBlack},0)`,
    background: "transparent",
    focus: {
        border: theme.colors.primaryLight,
    },
    hover: {
        background: `rgba(${theme.colors.transparentBlack},0.08)`,
    },
    active: {
        background: theme.colors.grey15,
        border: theme.colors.grey15,
        color: theme.colors.white,
    },
    disabled: {
        color: `rgba(${theme.colors.transparentBlack},0.26)`,
    },
});
const flatInverted = (theme) => ({
    type: "flatInverted",
    color: theme.colors.white,
    border: `rgba(${theme.colors.transparentBlack},0)`,
    background: "transparent",
    focus: {
        border: theme.colors.primaryLight,
    },
    hover: {
        background: `rgba(${theme.colors.transparentWhite},0.7)`,
        color: theme.colors.black,
    },
    active: {
        background: theme.colors.white,
        border: `rgba(${theme.colors.transparentBlack},0)`,
        color: theme.colors.black,
    },
    disabled: {
        border: `rgba(${theme.colors.transparentBlack},0)`,
        color: `rgba(${theme.colors.transparentWhite},0.4)`,
    },
});
const icon = (theme) => ({
    type: "icon",
    color: theme.colors.black,
    border: `rgba(${theme.colors.transparentBlack},0)`,
    background: "transparent",
    focus: {
        border: theme.colors.primaryLight,
    },
    hover: {
        background: `rgba(${theme.colors.transparentBlack},0.08)`,
        border: `rgba(${theme.colors.transparentBlack},0)`,
        color: theme.colors.black,
    },
    active: {
        background: theme.colors.grey15,
        border: theme.colors.grey15,
        color: theme.colors.white,
    },
    disabled: {
        background: "transparent",
        border: `rgba(${theme.colors.transparentBlack},0)`,
        color: `rgba(${theme.colors.transparentBlack},0.26)`,
    },
});
const iconInverted = (theme) => ({
    type: "iconInverted",
    background: "transparent",
    border: `rgba(${theme.colors.transparentBlack},0)`,
    color: theme.colors.white,
    focus: {
        border: theme.colors.primaryLight,
    },
    hover: {
        background: `rgba(${theme.colors.transparentWhite},0.7)`,
        border: `rgba(${theme.colors.transparentBlack},0)`,
        color: theme.colors.black,
    },
    active: {
        background: theme.colors.white,
        color: theme.colors.black,
    },
    disabled: {
        color: `rgba(${theme.colors.transparentWhite},0.4)`,
    },
});
const iconInvertedOnColor = (theme) => ({
    type: "iconInvertedOnColor",
    background: "transparent",
    border: `rgba(${theme.colors.transparentBlack},0)`,
    color: theme.colors.white,
    focus: {
        border: theme.colors.primaryDark,
    },
    hover: {
        background: `rgba(${theme.colors.transparentWhite},0.7)`,
        border: `rgba(${theme.colors.transparentBlack},0)`,
        color: theme.colors.black,
    },
    active: {
        background: theme.colors.white,
        color: theme.colors.black,
        border: `rgba(${theme.colors.transparentBlack},0)`,
    },
    disabled: {
        border: `rgba(${theme.colors.transparentBlack},0)`,
        color: `rgba(${theme.colors.transparentWhite},0.4)`,
    },
});
export const buttonStyles = (theme) => ({
    primary: primary(theme),
    secondary: secondary(theme),
    inverse: {
        type: "inverse",
        color: theme.colors.white,
        background: theme.colors.grey15,
        border: theme.colors.grey15,
        focus: {
            border: theme.colors.primaryLight,
        },
        hover: {
            background: theme.colors.grey14,
            border: theme.colors.grey14,
        },
        active: {
            background: theme.colors.grey09,
            border: theme.colors.grey09,
        },
        disabled: {
            color: `rgba(${theme.colors.transparentBlack},0.3)`,
            background: `rgba(${theme.colors.transparentBlack},0)`,
            border: `rgba(${theme.colors.transparentBlack},0)`,
        },
    },
    primaryInverted: Object.assign(Object.assign({}, primary(theme)), { focus: {
            border: theme.colors.primaryDark,
        }, disabled: {
            background: `rgba(${theme.colors.transparentWhite},0.12)`,
            border: `rgba(${theme.colors.transparentWhite},0)`,
            color: `rgba(${theme.colors.transparentWhite},0.3)`,
        } }),
    primaryInvertedOnColor: primaryInvertedOnColor(theme),
    secondaryInverted: secondaryInverted(theme),
    secondaryInvertedOnColor: Object.assign(Object.assign({}, secondaryInverted(theme)), { focus: {
            border: theme.colors.primaryDark,
        } }),
    flat: flat(theme),
    flatLight: Object.assign(Object.assign({}, flat(theme)), { color: theme.colors.grey14 }),
    flatHighlight: Object.assign(Object.assign({}, flat(theme)), { color: theme.colors.primaryLight }),
    flatInverted: flatInverted(theme),
    flatInvertedOnColor: Object.assign(Object.assign({}, flatInverted(theme)), { focus: {
            border: theme.colors.primaryDark,
        } }),
    icon: icon(theme),
    iconHighlight: Object.assign(Object.assign({}, icon(theme)), { type: "iconHighlight", color: theme.colors.primaryLight, focus: {
            border: theme.colors.primaryLight,
        }, hover: {
            background: `rgba(${theme.colors.transparentBlack},0.08)`,
            border: `rgba(${theme.colors.transparentBlack},0)`,
            color: theme.colors.primaryLight,
        } }),
    iconOutline: Object.assign(Object.assign({}, icon(theme)), { type: "iconOutline", border: theme.colors.black, color: theme.colors.black, focus: {
            border: theme.colors.primaryLight,
        }, hover: {
            background: `rgba(${theme.colors.transparentBlack},0.08)`,
            color: theme.colors.black,
        }, disabled: {
            color: `rgba(${theme.colors.transparentBlack},0.26)`,
            background: "transparent",
            border: `rgba(${theme.colors.transparentBlack},0.26)`,
        } }),
    iconFlat: Object.assign(Object.assign({}, icon(theme)), { type: "iconFlat", background: `rgba(${theme.colors.transparentBlack},0.08)`, focus: {
            border: theme.colors.primaryLight,
        }, hover: {
            background: `rgba(${theme.colors.transparentBlack},0.15)`,
        }, disabled: {
            background: `rgba(${theme.colors.transparentBlack},0.08)`,
            color: `rgba(${theme.colors.transparentBlack},0.2)`,
            border: `rgba(${theme.colors.transparentBlack},0)`,
        } }),
    iconInverted: iconInverted(theme),
    iconInvertedOutline: Object.assign(Object.assign({}, iconInverted(theme)), { type: "iconInvertedOutline", border: theme.colors.white, hover: {
            border: theme.colors.black,
            color: theme.colors.black,
            background: `rgba(${theme.colors.transparentWhite},0.70)`,
        }, active: {
            background: theme.colors.white,
            border: theme.colors.black,
        }, disabled: {
            border: `rgba(${theme.colors.transparentWhite},0.4)`,
            color: `rgba(${theme.colors.transparentWhite},0.4)`,
            background: "transparent",
        } }),
    iconInvertedFlat: Object.assign(Object.assign({}, iconInverted(theme)), { type: "iconInvertedFlat", background: `rgba(${theme.colors.transparentWhite},0.12)`, border: `rgba(${theme.colors.transparentWhite},0)`, active: {
            border: `rgba(${theme.colors.transparentBlack},0)`,
            background: theme.colors.white,
        }, disabled: {
            background: `rgba(${theme.colors.transparentWhite},0.08)`,
            border: `rgba(${theme.colors.transparentBlack},0)`,
            color: `rgba(${theme.colors.transparentWhite},0.4)`,
        } }),
    iconInvertedOnColor: iconInvertedOnColor(theme),
    iconInvertedOutlineOnColor: Object.assign(Object.assign({}, iconInvertedOnColor(theme)), { type: "iconInvertedOutlineOnColor", border: theme.colors.white, focus: {
            border: theme.colors.primaryDark,
        }, hover: {
            background: `rgba(${theme.colors.transparentWhite},0.7)`,
            border: theme.colors.black,
            color: theme.colors.black,
        }, active: {
            background: theme.colors.white,
            border: theme.colors.black,
            color: theme.colors.black,
        }, disabled: {
            border: `rgba(${theme.colors.transparentWhite},0.4)`,
            color: `rgba(${theme.colors.transparentWhite},0.4)`,
            background: "transparent",
        } }),
    iconInvertedFlatOnColor: Object.assign(Object.assign({}, iconInvertedOnColor(theme)), { type: "iconInvertedFlatOnColor", background: `rgba(${theme.colors.transparentWhite},0.12)`, border: "transparent", hover: {
            border: `rgba(${theme.colors.transparentBlack},0)`,
            background: `rgba(${theme.colors.transparentWhite},0.7)`,
            color: theme.colors.black,
        }, active: {
            border: `rgba(${theme.colors.transparentBlack},0)`,
            background: theme.colors.white,
            color: theme.colors.black,
        }, disabled: {
            background: `rgba(${theme.colors.transparentWhite},0.08)`,
            border: `rgba(${theme.colors.transparentBlack},0)`,
            color: `rgba(${theme.colors.transparentWhite},0.4)`,
        } }),
    iconBackground: {
        type: "iconBackground",
        color: theme.colors.black,
        border: `rgba(${theme.colors.transparentBlack},0)`,
        background: `rgba(${theme.colors.transparentBlack},0.08)`,
        focus: {
            border: theme.colors.primaryLight,
        },
        hover: {
            background: `rgba(${theme.colors.transparentBlack},0.15)`,
            color: theme.colors.black,
        },
        active: {
            background: theme.colors.grey15,
            border: theme.colors.grey15,
            color: theme.colors.white,
        },
        disabled: {
            background: `rgba(${theme.colors.transparentBlack},0.08)`,
            color: `rgba(${theme.colors.transparentBlack},0.2)`,
        },
    },
    iconDark: {
        type: "iconDark",
        color: theme.colors.white,
        border: `rgba(${theme.colors.transparentBlack},0)`,
        background: `rgba(${theme.colors.transparentBlack},0.8)`,
        focus: {
            border: theme.colors.primaryLight,
        },
        hover: {
            background: `rgba(${theme.colors.transparentBlack},0.6)`,
        },
        active: {
            background: theme.colors.black,
            border: theme.colors.black,
        },
    },
    video: {
        type: "video",
        color: theme.colors.white,
        border: theme.colors.white,
        background: `rgba(${theme.colors.transparent15},0.5)`,
        focus: {
            border: theme.colors.primaryLight,
        },
        hover: {
            background: `rgba(${theme.colors.transparent15},0.8)`,
        },
        active: {
            background: theme.colors.grey15,
        },
        disabled: {
            background: `rgba(${theme.colors.transparent15},0.2)`,
            border: `rgba(${theme.colors.transparentWhite},0.3)`,
            color: `rgba(${theme.colors.transparentWhite},0.3)`,
        },
    },
});
